import { render } from "./HighSchoolScoreVsCurrentGpaScatter.vue?vue&type=template&id=006244c8"
import script from "./HighSchoolScoreVsCurrentGpaScatter.vue?vue&type=script&lang=js"
export * from "./HighSchoolScoreVsCurrentGpaScatter.vue?vue&type=script&lang=js"
script.render = render

export default script